import React, { useState, useEffect } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Button } from "react-bootstrap";
import Select from "react-select";
import { selectStyles } from "../helper/SelectStyles";
import TablePagination from "./TablePagination";

const BookingStatusLayer = () => {
  const [expoOptions, setExpoOptions] = useState([
    { value: "expo1", label: "Global Trade Fair 2026" },
    { value: "expo2", label: "Tech Expo 2026" },
  ]);
  const [selectedExpo, setSelectedExpo] = useState(null);
  const [data, setData] = useState([
    {
      _id: "1",
      expoName: "Global Trade Fair 2026",
      companyName: "Innovate Inc",
      keyPerson: "John Doe",
      mobile: "9000012345",
      city: "Delhi",
      employeeName: "Admin User",
      ratings: "5",
      history: "3 participations",
    },
    {
      _id: "2",
      expoName: "Tech Expo 2026",
      companyName: "Global Logistics",
      keyPerson: "Jane Smith",
      mobile: "9000054321",
      city: "Mumbai",
      employeeName: "Admin User",
      ratings: "4",
      history: "1 participation",
    },
  ]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRecords, setTotalRecords] = useState(2);
  const [isAddBooking, setIsAddBooking] = useState(false);

  const [formErrors, setFormErrors] = useState({});
  const [bookingData, setBookingData] = useState({
    companyName: "",
    contactPerson: "",
    mobileNumber: "",
    email: "",
    stallNo: "",
    stallSizeL: "",
    stallSizeW: "",
    ratePerSqMt: "500",
    bookingAmount: "",
    gst: "",
    status: "confirmation",
    additionalRequirements: [{ name: "", quantity: "", notes: "" }],
  });

  const [viewBookingData, setViewBookingData] = useState(null);

  const handleAddRequirement = () => {
    setBookingData((prev) => ({
      ...prev,
      additionalRequirements: [
        ...prev.additionalRequirements,
        { name: "", quantity: "", notes: "" },
      ],
    }));
  };

  const handleRequirementChange = (index, field, value) => {
    setBookingData((prev) => {
      const newReqs = [...prev.additionalRequirements];
      newReqs[index][field] = value;
      return { ...prev, additionalRequirements: newReqs };
    });
    if (formErrors[`req_${index}_name`]) {
      setFormErrors((prev) => ({ ...prev, [`req_${index}_name`]: null }));
    }
  };

  const handleRemoveRequirement = (index) => {
    setBookingData((prev) => {
      const newReqs = [...prev.additionalRequirements];
      newReqs.splice(index, 1);
      return { ...prev, additionalRequirements: newReqs };
    });
  };

  const bookingAmountNum = parseFloat(bookingData.bookingAmount) || 0;
  const gstNum = parseFloat(bookingData.gst) || 0;
  const calculatedTotalAmount =
    bookingAmountNum + (bookingAmountNum * gstNum) / 100;

  const handleSearch = () => {
    setLoading(true);
    setTimeout(() => setLoading(false), 500);
  };

  const handleBookingInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "mobileNumber") {
      const digitsOnly = value.replace(/\D/g, "").slice(0, 10);
      setBookingData((prev) => ({ ...prev, [name]: digitsOnly }));
      return;
    }
    if (e.target.type === "number" && value < 0) return;

    setBookingData((prev) => {
      const newData = { ...prev, [name]: value };

      if (
        name === "stallSizeL" ||
        name === "stallSizeW" ||
        name === "ratePerSqMt"
      ) {
        const l = parseFloat(newData.stallSizeL) || 0;
        const w = parseFloat(newData.stallSizeW) || 0;
        const rate = parseFloat(newData.ratePerSqMt) || 0;

        if (l > 0 && w > 0 && rate > 0) {
          newData.bookingAmount = (l * w * rate).toFixed(2);
        }
      }
      return newData;
    });

    // Clear error when user types
    if (formErrors[name]) {
      setFormErrors((prev) => ({ ...prev, [name]: null }));
    }
  };

  const validateBookingForm = () => {
    let errors = {};
    if (!bookingData.companyName.trim())
      errors.companyName = "Company Name is Required";
    if (!bookingData.contactPerson.trim())
      errors.contactPerson = "Contact Person is Required";
    if (!bookingData.mobileNumber.trim())
      errors.mobileNumber = "Mobile Number is Required";
    else if (bookingData.mobileNumber.trim().length !== 10)
      errors.mobileNumber = "Mobile Number must be 10 digits";
    if (!bookingData.email.trim()) errors.email = "Email is Required";
    else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(bookingData.email)
    )
      errors.email = "Invalid email address";

    if (!bookingData.stallNo.trim()) errors.stallNo = "Stall No is Required";
    if (!bookingData.stallSizeL.trim() || !bookingData.stallSizeW.trim())
      errors.stallSize = "Size (L x W) is Required";
    if (!bookingData.ratePerSqMt.trim())
      errors.ratePerSqMt = "Rate is Required";
    if (!bookingData.bookingAmount.trim())
      errors.bookingAmount = "Booking Amount is Required";
    if (!bookingData.status) errors.status = "Status is Required";

    bookingData.additionalRequirements.forEach((req, idx) => {
      if (
        req.name.trim() === "" &&
        (req.quantity !== "" || req.notes.trim() !== "")
      ) {
        errors[`req_${idx}_name`] = "Item Name is Required";
      } else if (
        req.name.trim() === "" &&
        req.quantity === "" &&
        req.notes.trim() === ""
      ) {
        // Ignore completely empty rows
      }
    });

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleBookingSubmit = (e) => {
    e.preventDefault();
    if (validateBookingForm()) {
      setIsAddBooking(false);
      setBookingData({
        companyName: "",
        contactPerson: "",
        mobileNumber: "",
        email: "",
        stallNo: "",
        stallSizeL: "",
        stallSizeW: "",
        ratePerSqMt: "500",
        bookingAmount: "",
        gst: "",
        status: "confirmation",
        additionalRequirements: [{ name: "", quantity: "", notes: "" }],
      });
      setFormErrors({});
    }
  };

  if (viewBookingData) {
    return (
      <div className="card h-100 p-0 radius-12">
        <div
          className="card-header border-bottom px-24 py-12 d-flex align-items-center justify-content-between"
          style={{
            background:
              "linear-gradient(135deg, #000000ff, #bb0007ff, #ff0000ff)",
          }}
        >
          <h6 className="text-white pb-2 mb-0" style={{ fontWeight: "700" }}>
            VIEW BOOKING DETAILS
          </h6>
          <button
            className="btn btn-sm d-flex align-items-center gap-1"
            style={{
              backgroundColor: "#f7e7da",
              color: "black",
              fontWeight: "600",
            }}
            onClick={() => setViewBookingData(null)}
          >
            <Icon icon="solar:arrow-left-bold" />
            Back to List
          </button>
        </div>
        <div className="card-body p-24" style={{ overflowY: "auto" }}>
          <div className="row gy-4">
            {/* EXPO INFO */}
            <div className="col-12">
              <h6 className="mb-0 text-danger" style={{ fontWeight: "bold" }}>
                EXPO INFO
              </h6>
            </div>
            <div className="col-md-3">
              <label className="form-label fw-bold">Expo Name</label>
              <p className="mb-0 text-muted">
                {viewBookingData.expoName || "Earth Expo - Mall"}
              </p>
            </div>
            <div className="col-md-3">
              <label className="form-label fw-bold">Date</label>
              <p className="mb-0 text-muted">15 Nov 2024 to 17 Nov 2024</p>
            </div>
            <div className="col-md-3">
              <label className="form-label fw-bold">Venue</label>
              <p className="mb-0 text-muted">Coimbatore</p>
            </div>
            <div className="col-md-3">
              <label className="form-label fw-bold">Location</label>
              <p className="mb-0 text-muted">Coimbatore</p>
            </div>

            <div className="col-12 my-1">
              <hr className="text-muted m-0" />
            </div>

            {/* CLIENT INFO */}
            <div className="col-12 mt-2">
              <h6 className="mb-0 text-danger" style={{ fontWeight: "bold" }}>
                CLIENT INFO
              </h6>
            </div>
            <div className="col-md-6">
              <label className="form-label fw-bold">Company Name</label>
              <p className="mb-0 text-muted">
                {viewBookingData.companyName || "-"}
              </p>
            </div>
            <div className="col-md-6">
              <label className="form-label fw-bold">Contact Person</label>
              <p className="mb-0 text-muted">
                {viewBookingData.keyPerson || "-"}
              </p>
            </div>
            <div className="col-md-6">
              <label className="form-label fw-bold">Mobile Number</label>
              <p className="mb-0 text-muted">{viewBookingData.mobile || "-"}</p>
            </div>
            <div className="col-md-6">
              <label className="form-label fw-bold">City</label>
              <p className="mb-0 text-muted">{viewBookingData.city || "-"}</p>
            </div>

            <div className="col-12 my-1">
              <hr className="text-muted m-0" />
            </div>

            {/* BOOKING INFO */}
            <div className="col-12 mt-2">
              <h6 className="mb-0 text-danger" style={{ fontWeight: "bold" }}>
                BOOKING INFO
              </h6>
            </div>
            <div className="col-md-3">
              <label className="form-label fw-bold">Stall No</label>
              <p className="mb-0 text-muted">
                {viewBookingData.stallNo || "Not Assigned"}
              </p>
            </div>

            <div className="col-12 my-1">
              <hr className="text-muted m-0" />
            </div>

            {/* ADDITIONAL REQUIREMENTS */}
            <div className="col-12 mt-2">
              <h6 className="mb-0 text-danger" style={{ fontWeight: "bold" }}>
                ADDITIONAL REQUIREMENTS
              </h6>
              <p
                className="mb-1 text-success fw-bold"
                style={{ fontSize: "14px" }}
              >
                <Icon icon="mdi:check-circle" className="me-1" />
                Default Inclusions: Table, Chair, Basic Lighting
              </p>
            </div>

            {viewBookingData.additionalRequirements &&
              viewBookingData.additionalRequirements.length > 0 ? (
              <div className="col-12">
                <div className="table-responsive">
                  <table className="table table-bordered mb-0">
                    <thead style={{ backgroundColor: "#f8f9fa" }}>
                      <tr>
                        <th style={{ fontSize: "14px", fontWeight: "bold" }}>
                          Item Name
                        </th>
                        <th style={{ fontSize: "14px", fontWeight: "bold" }}>
                          Quantity
                        </th>
                        <th style={{ fontSize: "14px", fontWeight: "bold" }}>
                          Notes
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {viewBookingData.additionalRequirements.map(
                        (req, idx) => (
                          <tr key={idx}>
                            <td>{req.name}</td>
                            <td>{req.quantity || "-"}</td>
                            <td>{req.notes || "-"}</td>
                          </tr>
                        ),
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            ) : (
              <div className="col-12">
                <p className="text-muted fst-italic mb-0">
                  No additional requirements requested.
                </p>
              </div>
            )}

            <div className="col-12 mt-32 d-flex justify-content-end gap-3">
              <button
                className="btn radius-8 px-40 py-11"
                style={{
                  backgroundColor: "#ed1c24",
                  color: "white",
                  fontWeight: "700",
                }}
                onClick={() => setViewBookingData(null)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (isAddBooking) {
    return (
      <div className="card h-100 p-0 radius-12">
        {/* <div className="card-header border-bottom px-24 py-12 d-flex align-items-center justify-content-between" style={{ background: "linear-gradient(135deg, #000000ff, #bb0007ff, #ff0000ff)" }}>
                    <h6 className="text-white pb-2 mb-0" style={{ fontWeight: "700" }}>ADD BOOKING</h6>
                    <button className="btn btn-sm d-flex align-items-center gap-1" style={{ backgroundColor: "#f7e7da", color: "black", fontWeight: "600" }} onClick={() => setIsAddBooking(false)}>
                        <Icon icon="solar:arrow-left-bold" />
                        List Bookings
                    </button>
                </div> */}
        <div className="card-body p-24" style={{ overflowY: "auto" }}>
          {/* <div className="table-responsive mb-4">
                        <table className="table table-bordered text-center mb-0">
                            <tbody>
                                <tr>
                                    {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(num => <td key={num} className="py-2" style={{ fontSize: "14px", fontWeight: "bold" }}>{num}</td>)}
                                </tr>
                                <tr>
                                    {[11, 12, 13, 14, 15, 16, 17, 18, 19, 20].map(num => <td key={num} className="py-2" style={{ fontSize: "14px", fontWeight: "bold" }}>{num}</td>)}
                                </tr>
                            </tbody>
                        </table>
                    </div> */}

          <form onSubmit={handleBookingSubmit}>
            <div className="row gy-4">
              {/* EXPO INFO */}
              <div className="col-12">
                <h6 className="mb-0 text-danger" style={{ fontWeight: "bold" }}>
                  EXPO INFO
                </h6>
              </div>
              <div className="col-md-3">
                <label className="form-label fw-bold">Expo Name</label>
                <input
                  type="text"
                  className="form-control radius-8"
                  defaultValue="Earth Expo - Mall"
                  disabled
                />
              </div>
              <div className="col-md-3">
                <label className="form-label fw-bold">Date</label>
                <input
                  type="text"
                  className="form-control radius-8"
                  defaultValue="15 Nov 2024 to 17 Nov 2024"
                  disabled
                />
              </div>
              <div className="col-md-3">
                <label className="form-label fw-bold">Venue</label>
                <input
                  type="text"
                  className="form-control radius-8"
                  defaultValue="Coimbatore"
                  disabled
                />
              </div>
              <div className="col-md-3">
                <label className="form-label fw-bold">Location</label>
                <input
                  type="text"
                  className="form-control radius-8"
                  defaultValue="Coimbatore"
                  disabled
                />
              </div>

              <div className="col-12 my-1">
                <hr className="text-muted m-0" />
              </div>

              {/* CLIENT INFO */}
              <div className="col-12 mt-2">
                <h6 className="mb-0 text-danger" style={{ fontWeight: "bold" }}>
                  CLIENT INFO
                </h6>
              </div>
              <div className="col-md-6">
                <label className="form-label fw-bold">
                  Company Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="companyName"
                  value={bookingData.companyName}
                  onChange={handleBookingInputChange}
                  className={`form-control radius-8 ${formErrors.companyName ? "is-invalid" : ""}`}
                  placeholder="Enter Company Name"
                />
                {formErrors.companyName && (
                  <div className="invalid-feedback">
                    {formErrors.companyName}
                  </div>
                )}
              </div>
              <div className="col-md-6">
                <label className="form-label fw-bold">
                  Contact Person <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="contactPerson"
                  value={bookingData.contactPerson}
                  onChange={handleBookingInputChange}
                  className={`form-control radius-8 ${formErrors.contactPerson ? "is-invalid" : ""}`}
                  placeholder="Enter Contact Person"
                />
                {formErrors.contactPerson && (
                  <div className="invalid-feedback">
                    {formErrors.contactPerson}
                  </div>
                )}
              </div>
              <div className="col-md-6">
                <label className="form-label fw-bold">
                  Mobile Number <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="mobileNumber"
                  value={bookingData.mobileNumber}
                  onChange={handleBookingInputChange}
                  className={`form-control radius-8 ${formErrors.mobileNumber ? "is-invalid" : ""}`}
                  placeholder="Enter Mobile Number"
                />
                {formErrors.mobileNumber && (
                  <div className="invalid-feedback">
                    {formErrors.mobileNumber}
                  </div>
                )}
              </div>
              <div className="col-md-6">
                <label className="form-label fw-bold">
                  Email <span className="text-danger">*</span>
                </label>
                <input
                  type="email"
                  name="email"
                  value={bookingData.email}
                  onChange={handleBookingInputChange}
                  className={`form-control radius-8 ${formErrors.email ? "is-invalid" : ""}`}
                  placeholder="Enter Email"
                />
                {formErrors.email && (
                  <div className="invalid-feedback">{formErrors.email}</div>
                )}
              </div>
              <div className="col-md-12">
                <label className="form-label fw-bold">Address</label>
                <textarea
                  className="form-control radius-8"
                  rows="2"
                  placeholder="Enter Address"
                ></textarea>
              </div>

              <div className="col-12 my-1">
                <hr className="text-muted m-0" />
              </div>

              {/* BOOKING INFO */}
              <div className="col-12 mt-2">
                <h6 className="mb-0 text-danger" style={{ fontWeight: "bold" }}>
                  BOOKING INFO
                </h6>
              </div>
              <div className="col-md-4">
                <label className="form-label fw-bold">
                  Stall No <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="stallNo"
                  value={bookingData.stallNo}
                  onChange={handleBookingInputChange}
                  className={`form-control radius-8 ${formErrors.stallNo ? "is-invalid" : ""}`}
                  placeholder="E.g., 12A"
                />
                {formErrors.stallNo && (
                  <div className="invalid-feedback">{formErrors.stallNo}</div>
                )}
              </div>
              <div className="col-md-4">
                <label className="form-label fw-bold">
                  Stall Size (sq.ft) <span className="text-danger">*</span>
                </label>
                <div className="d-flex align-items-center gap-2">
                  <input
                    type="text"
                    name="stallSizeL"
                    value={bookingData.stallSizeL}
                    onChange={handleBookingInputChange}
                    className={`form-control radius-8 ${formErrors.stallSize ? "is-invalid" : ""}`}
                    placeholder="L"
                  />
                  <span className="fw-bold text-muted">X</span>
                  <input
                    type="text"
                    name="stallSizeW"
                    value={bookingData.stallSizeW}
                    onChange={handleBookingInputChange}
                    className={`form-control radius-8 ${formErrors.stallSize ? "is-invalid" : ""}`}
                    placeholder="W"
                  />
                </div>
                {formErrors.stallSize && (
                  <div className="invalid-feedback d-block">
                    {formErrors.stallSize}
                  </div>
                )}
              </div>
              <div className="col-md-4">
                <label className="form-label fw-bold">
                  Rate Per Sq/Mt <span className="text-danger">*</span>
                </label>
                <input
                  type="number"
                  name="ratePerSqMt"
                  value={bookingData.ratePerSqMt}
                  className="form-control radius-8 bg-light"
                  readOnly
                />
              </div>
              <div className="col-md-4">
                <label className="form-label fw-bold">
                  Booking Amount <span className="text-danger">*</span>
                </label>
                <input
                  type="number"
                  name="bookingAmount"
                  value={bookingData.bookingAmount}
                  onChange={handleBookingInputChange}
                  className={`form-control radius-8 ${formErrors.bookingAmount ? "is-invalid" : ""}`}
                  placeholder="Enter Amount"
                  min="0"
                />
                {formErrors.bookingAmount && (
                  <div className="invalid-feedback">
                    {formErrors.bookingAmount}
                  </div>
                )}
              </div>
              <div className="col-md-4">
                <label className="form-label fw-bold">GST (%)</label>
                <input
                  type="number"
                  name="gst"
                  value={bookingData.gst}
                  onChange={handleBookingInputChange}
                  className="form-control radius-8"
                  placeholder="Enter GST"
                  min="0"
                />
              </div>
              <div className="col-md-4">
                <label className="form-label fw-bold">Total Amount</label>
                <input
                  type="text"
                  className="form-control radius-8 bg-light"
                  value={
                    calculatedTotalAmount
                      ? calculatedTotalAmount.toFixed(2)
                      : "0"
                  }
                  readOnly
                />
              </div>
              <div className="col-md-6">
                <label className="form-label fw-bold">Stall Position</label>
                <Select
                  options={[
                    { value: "corner", label: "Corner" },
                    { value: "regular", label: "Regular" },
                  ]}
                  styles={selectStyles()}
                  placeholder="-- Select --"
                />
              </div>
              <div className="col-md-6">
                <label className="form-label fw-bold">
                  Status <span className="text-danger">*</span>
                </label>
                <Select
                  options={[
                    { value: "confirmation", label: "Confirmation" },
                    { value: "tentative", label: "Tentative" },
                  ]}
                  styles={selectStyles()}
                  placeholder="-- Select --"
                  value={{
                    value: bookingData.status,
                    label:
                      bookingData.status.charAt(0).toUpperCase() +
                      bookingData.status.slice(1),
                  }}
                  onChange={(opt) => {
                    setBookingData((prev) => ({ ...prev, status: opt.value }));
                    setFormErrors((prev) => ({ ...prev, status: null }));
                  }}
                  className={formErrors.status ? "is-invalid" : ""}
                />
                {formErrors.status && (
                  <div className="invalid-feedback d-block">
                    {formErrors.status}
                  </div>
                )}
              </div>
              <div className="col-md-12">
                <label className="form-label fw-bold">Remarks</label>
                <textarea
                  className="form-control radius-8"
                  rows="3"
                  placeholder="Enter Remarks"
                ></textarea>
              </div>

              <div className="col-12 my-1">
                <hr className="text-muted m-0" />
              </div>

              {/* DYNAMIC EXTRAS */}
              <div className="col-12 mt-2 d-flex justify-content-between align-items-center">
                <div>
                  <h6
                    className="mb-0 text-danger"
                    style={{ fontWeight: "bold" }}
                  >
                    ADDITIONAL REQUIREMENTS
                  </h6>
                  <small className="text-muted">
                    Default Inclusions: Table, Chair, Basic Lighting
                  </small>
                </div>
                <button
                  type="button"
                  className="btn btn-sm d-flex align-items-center gap-1"
                  style={{
                    backgroundColor: "#ed1c24",
                    color: "white",
                    fontWeight: "600",
                  }}
                  onClick={handleAddRequirement}
                >
                  <Icon icon="ic:baseline-plus" className="text-xl" /> Add Item
                </button>
              </div>

              {bookingData.additionalRequirements.map((req, index) => (
                <div key={index} className="col-12">
                  <div
                    className="p-3 radius-8"
                    style={{
                      border: "1px solid #dee2e6",
                      backgroundColor: "#f8f9fa",
                    }}
                  >
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <span className="fw-bold">Item {index + 1}</span>
                      <button
                        type="button"
                        className="btn btn-sm p-0 text-danger"
                        onClick={() => handleRemoveRequirement(index)}
                      >
                        <Icon
                          icon="mdi:trash-can-outline"
                          style={{ fontSize: "20px" }}
                        />
                      </button>
                    </div>
                    <div className="row gy-3">
                      <div className="col-md-4">
                        <label
                          className="form-label fw-bold"
                          style={{ fontSize: "14px" }}
                        >
                          Item Name <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className={`form-control radius-8 ${formErrors[`req_${index}_name`] ? "is-invalid" : ""}`}
                          placeholder="e.g., LED Screen"
                          value={req.name}
                          onChange={(e) =>
                            handleRequirementChange(
                              index,
                              "name",
                              e.target.value,
                            )
                          }
                        />
                        {formErrors[`req_${index}_name`] && (
                          <div className="invalid-feedback">
                            {formErrors[`req_${index}_name`]}
                          </div>
                        )}
                      </div>
                      <div className="col-md-3">
                        <label
                          className="form-label fw-bold"
                          style={{ fontSize: "14px" }}
                        >
                          Quantity
                        </label>
                        <input
                          type="number"
                          className="form-control radius-8"
                          placeholder="e.g., 2"
                          value={req.quantity}
                          onChange={(e) => {
                            const val = e.target.value;
                            if (val < 0) return;
                            handleRequirementChange(index, "quantity", val);
                          }}
                          min="1"
                        />
                      </div>
                      <div className="col-md-5">
                        <label
                          className="form-label fw-bold"
                          style={{ fontSize: "14px" }}
                        >
                          Notes / Description
                        </label>
                        <input
                          type="text"
                          className="form-control radius-8"
                          placeholder="e.g., Front entrance branding"
                          value={req.notes}
                          onChange={(e) =>
                            handleRequirementChange(
                              index,
                              "notes",
                              e.target.value,
                            )
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              ))}

              {/* Buttons */}
              <div className="col-12 mt-32 d-flex justify-content-end gap-3">
                <button
                  type="button"
                  className="btn radius-8 px-40 py-11"
                  style={{
                    backgroundColor: "white",
                    color: "#d9534f",
                    fontWeight: "700",
                    border: "1px solid #d9534f",
                  }}
                  onClick={() => setIsAddBooking(false)}
                >
                  Cancel
                </button>
                {/* <button
                                    type="button"
                                    className="btn radius-8 px-40 py-11"
                                    style={{ backgroundColor: "#ffc107", color: "black", fontWeight: "700" }}
                                >
                                    Draft Booking
                                </button> */}
                <button
                  type="submit"
                  className="btn radius-8 px-48 py-11"
                  style={{
                    backgroundColor: "#ed1c24",
                    color: "white",
                    fontWeight: "700",
                  }}
                >
                  Save
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div className="card h-100 p-0 radius-12">
      <div
        className="card-header border-bottom py-12 px-24 d-flex align-items-center justify-content-between"
        style={{
          background:
            "linear-gradient(135deg, #000000ff, #bb0007ff, #ff0000ff)",
        }}
      >
        <h6 className="mb-0" style={{ color: "#fff", fontWeight: "700" }}>
          STALL BOOKING STATUS
        </h6>
      </div>
      <div className="card-body p-24">
        <div
          className="d-flex align-items-center gap-3 mb-24 p-16 radius-8"
          style={{ border: "1px solid #f7e7da" }}
        >
          <label className="fw-bold mb-0">Expo Name :</label>
          <div style={{ width: "300px" }}>
            <Select
              options={expoOptions}
              value={selectedExpo}
              onChange={setSelectedExpo}
              styles={selectStyles()}
              placeholder="-- Select --"
            />
          </div>
          <button
            className="btn px-24 py-8"
            onClick={handleSearch}
            style={{
              backgroundColor: "#e9ecef",
              border: "1px solid #ced4da",
              color: "black",
            }}
          >
            Search
          </button>
        </div>

        <div className="table-responsive">
          <table className="table bordered-table sm-table mb-0">
            <thead>
              <tr style={{ backgroundColor: "#f7e7da" }}>
                <th scope="col" style={{ color: "black", fontWeight: "bold" }}>
                  S.No
                </th>
                <th scope="col" style={{ color: "black", fontWeight: "bold" }}>
                  Expo Name
                </th>
                <th scope="col" style={{ color: "black", fontWeight: "bold" }}>
                  Company Name
                </th>
                <th scope="col" style={{ color: "black", fontWeight: "bold" }}>
                  Key Person
                </th>
                <th scope="col" style={{ color: "black", fontWeight: "bold" }}>
                  Mobile
                </th>
                <th scope="col" style={{ color: "black", fontWeight: "bold" }}>
                  City
                </th>
                <th scope="col" style={{ color: "black", fontWeight: "bold" }}>
                  Employee Name
                </th>
                <th scope="col" style={{ color: "black", fontWeight: "bold" }}>
                  Ratings
                </th>
                <th scope="col" style={{ color: "black", fontWeight: "bold" }}>
                  Business History
                </th>
                <th scope="col" style={{ color: "black", fontWeight: "bold" }}>
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {data.length > 0 ? (
                data.map((item, index) => (
                  <tr key={item._id || index}>
                    <td>{currentPage * rowsPerPage + index + 1}</td>
                    <td>{item.expoName}</td>
                    <td>{item.companyName}</td>
                    <td>{item.keyPerson}</td>
                    <td>{item.mobile}</td>
                    <td>{item.city}</td>
                    <td>{item.employeeName}</td>
                    <td className="text-center">
                      <div className="d-flex align-items-center justify-content-center gap-1">
                        <Icon
                          icon="solar:star-bold"
                          className="text-warning-main"
                        />
                        <span>
                          {(() => {
                            const r = String(item.ratings || "");
                            const mapping = { "1": "VIP", "2": "ENQUIRY", "3": "OTHER EXHIBITOR", "4": "OWN EXHIBITOR" };
                            return mapping[r] || r || "OTHER EXHIBITOR";
                          })()}
                        </span>
                      </div>
                    </td>
                    <td className="text-center">{item.history}</td>
                    <td className="text-center">
                      <div className="d-flex align-items-center justify-content-center gap-2">
                        {/* <button
                                                    className="btn btn-sm d-flex align-items-center gap-1"
                                                    style={{ backgroundColor: "#ed1c24", color: "white" }}
                                                    onClick={() => setIsAddBooking(true)}
                                                >
                                                    <Icon icon="ic:baseline-plus" className="text-lg" />
                                                    Add Booking
                                                </button> */}
                        <button
                          className="bg-info-focus bg-hover-info-200 text-info-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                          onClick={() => setViewBookingData(item)}
                        >
                          <Icon
                            icon="majesticons:eye-line"
                            className="icon text-xl"
                          />
                        </button>
                        {/* <Link
                                                    to={`/employees/view/${user._id}`}
                                                    className="bg-info-focus bg-hover-info-200 text-info-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                >
                                                    <Icon
                                                        icon="majesticons:eye-line"
                                                        className="icon text-xl"
                                                    />
                                                </Link> */}
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="10" className="text-center py-4">
                    No data available in table
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <TablePagination
          currentPage={currentPage}
          totalPages={Math.ceil(totalRecords / rowsPerPage)}
          onPageChange={setCurrentPage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={(e) => setRowsPerPage(parseInt(e.target.value))}
          totalRecords={totalRecords}
        />
      </div>
    </div>
  );
};

export default BookingStatusLayer;
